import styled from "styled-components";

const VerticalDivider = styled.div`
  border-left: var(--p-border-width-1) solid var(--p-color-border-subdued);
`;

export default VerticalDivider;
